import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getAlldecision = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DECISION + `/getAll`);
};

export const getdecisionById = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DECISION + `/getById/${id}`);
};

export const getdecisiongetByAppId = (appointmentId, type) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DECISION + `/getByAppId/${appointmentId}/${type}`);
};

export const createdecision = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.DECISION, data);
};

export const updatedecision = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.DECISION + `/${id}`, data);
};


export const deletedecision = (id) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.DECISION + `/${id}`);
};